import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { IAddVoucherPopup } from '../../shared/types';
import { getPaymentDetailsQuery, loadValuesQuery } from '../../shared/queries';
import ReceiptVoucherForm from './ReceiptVoucherForm';

const ReceiptVoucherPopup: React.FC<IAddVoucherPopup> = ({
  onSuccess,
  onClose,
  isEdit = false,
  currentPaymentId,
}) => {
  const [loading, setLoading] = useState(true);
  const businessPartnerId = useParams().id;
  const { data: valuesData } = useQuery(loadValuesQuery, {
    variables: { id: businessPartnerId },
  });
  const { data: paymentDetails } = useQuery(getPaymentDetailsQuery, {
    variables: { PaymentID: currentPaymentId },
    skip: !currentPaymentId,
    onCompleted: () => {
      setLoading(false);
    },
  });

  return (
    <ReceiptVoucherForm
      onSuccess={onSuccess}
      onClose={onClose}
      isEdit={isEdit}
      currentPaymentId={currentPaymentId}
      detailsLoading={loading}
      data={{
        values: valuesData,
        queries: paymentDetails?.Accounting?.queries,
      }}
    />
  );
};

export default ReceiptVoucherPopup;
